<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${resellerPayment.code}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="resellerPayment" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "resellerPayment-view-logs",

  components: { LogListTable },

  props: ["resellerPayment"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
